/**
 * @param {number} monthNumber
 * @return {string}
 */
export function readableExperienceFromMonthNumber(monthNumber) {
  if (monthNumber < 12) {
    return monthNumber + ' mois'
  }

  let years = Math.floor(monthNumber/12);
  let months = monthNumber % 12;

  let strDuration = years + ' ' + (years === 1 ? 'an' : 'ans');

  if (months > 0) {
    strDuration +=  (' et ' + months + ' mois');
  }

  return strDuration;
}

export function prepareFreelanceBeforeSubmit(freelance) {
  return {
    ...freelance,
    agent: freelance.agent ? freelance.agent.id : null,
  }
}
